<div ngbDropdown *ngIf="languages.length" class="text-right" placement="top-right">
  <button class="btn btn-outline-light dropdown-toggle btn-sm" id="dropdownBasic1" type="button" ngbDropdownToggle>
    {{"LANGUAGE"|translate}}
  </button>
  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
    <button class="dropdown-item" *ngFor="let lang of languages" [class.disabled]="isCurrentLanguage(lang.language)" (click)="onLangSelect(lang.language)">{{lang.name}}</button>
  </div>
</div>